export const legalDocuments = {
	terms: {
		path: "/legal/terms-and-conditions.md",
	},
	privacy: {
		path: "/legal/privacy-policy.md",
	},
}
